import request from '../utils/request'
import { ssHost, ssPortalHost } from '../config/host'
import { NODE_ENV } from '@com/config/env'
import { warehouseHost } from '../../config/apiHost'

export function creatGifTask(data, hostType) {
  return request({
    url: `${
      hostType === 'ss' ? ssHost : ssPortalHost
    }/api/v1/playturbo/ec2gif/create`,
    method: 'post',
    data,
  })
}

export function getEndcardInfo(data) {
  return request({
    url: `${warehouseHost[NODE_ENV]}/openapi/ec2gif/preview_url`,
    method: 'post',
    data,
  })
}
